export const SET_CENTRIFUGO_CONNECTED = 'SET_CENTRIFUGO_CONNECTED';
export const SET_CENTRIFUGO_ERROR = 'SET_CENTRIFUGO_ERROR';
export const SET_CENTRIFUGO_DISCONNECTED = 'SET_CENTRIFUGO_DISCONNECTED';
export const SET_CENTRIFUGO_INITIAL_DATA = 'SET_CENTRIFUGO_INITIAL_DATA';

export const SET_PERSONAL_INFO = 'SET_PERSONAL_INFO';
export const MARK_AS_SHOWN = 'MARK_AS_SHOWN';
export const USER_IS_READY_FOR_NEW_PERSONAL_DATA =
  'USER_IS_READY_FOR_NEW_PERSONAL_DATA';

export enum CENTRIFUGO_EVENTS_MAP {
  CONNECT = 'CONNECT',
  PUBLICATION = 'PUBLICATION',
  DISCONNECT = 'DISCONNECT',
  ERROR = 'ERROR',
}

export const PERSONAL_EVENTS = {
  INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
};
